<template>
    <div class="date-picker">
    <div class="month-picker">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" offset-y>
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="selectedMonth"
          class="month-field"
          :label="$t('inputs.datePickerMultiple.month')"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker 
        v-model="selectedDate"
        ref="picker"
        :type="type"
        :max="maxDate"
        :min="minDate"
        @input="onInput"
      ></v-date-picker>
    </v-menu>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "DatePickermultiple",
    props: {
      year: {
        type: Boolean,
        default: true,
      },
      month: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        menu: false,
        selectedDate: null,
      };
    },
    computed: {
      type() {
        if (this.year && this.month) {
          return 'month';
        } else if (this.year) {
          return 'year';
        } else {
          return 'month';
        }
      },
      selectedMonth() {
        if (this.selectedDate) {
          const date = new Date(this.selectedDate);
          const year = date.getFullYear();
          const month = date.toLocaleString('default', { month: 'long' });
          return `${month} ${year}`;
        } else {
          return '';
        }
      },
      maxDate() {
        const date = new Date();
        if (this.year) {
          const year = date.getFullYear();
          return `${year}-12-31`;
        } else {
          return null;
        }
      },
      minDate() {
        if (this.year && this.month) {
          const date = new Date();
          const year = date.getFullYear() - 10;
          return `${year}-01-01`;
        } else if (this.year) {
          const date = new Date();
          const year = date.getFullYear() - 100;
          return `${year}-01-01`;
        } else {
          return null;
        }
      },
    },
    methods: {
      onInput(value) {
        this.menu = false;
        this.$emit('input', value);
      },
    },
  };
  </script>
 <style>
 .v-date-picker-table .v-btn--active .v-btn__content,
 .v-date-picker-table .v-btn--active:focus .v-btn__content,
 .v-date-picker-table .v-btn--active:active .v-btn__content {
   color: #fff !important;
   background-color: red !important;
 }
</style>
  